import axios from "axios";

const fetchBlogs = async (page, limit) => {
  try {
    const response = await axios.get(
      `https://admin.sixdindia.com/blog_list_api.php?page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching blog data:", error);
    throw error;
  }
};

export default fetchBlogs;
